import { Link } from "@tanstack/react-router";
import { Check } from "@phosphor-icons/react";

export function SuccessScreen() {
  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-4">
      <div className="mx-auto max-w-md text-center">
        <div className="mx-auto flex size-20 items-center justify-center rounded-2xl bg-emerald-50">
          <Check className="size-10 text-emerald-600" />
        </div>
        <h2
          className="mt-6 text-2xl font-bold text-foreground sm:text-3xl"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          Prijava uspješno poslana!
        </h2>
        <p className="mt-3 text-muted-foreground">
          Vaša prijava je primljena. Administrator će pregledati vaš profil i
          obavijestiti vas o odluci putem emaila.
        </p>
        <div className="mt-6 flex items-center justify-center gap-2">
          <div className="size-1.5 animate-pulse rounded-full bg-primary/40" />
          <span className="text-sm text-muted-foreground">
            Preusmjeravanje na početnu...
          </span>
        </div>
        <Link
          to="/"
          className="mt-3 inline-flex text-sm font-medium text-primary hover:underline"
        >
          Ili kliknite ovdje
        </Link>
      </div>
    </div>
  );
}
